import { Button, Grid, Paper, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  Control,
  FieldErrors,
  UseFormRegister,
  UseFormReset,
} from "react-hook-form";
import WSSelectField from "../../Components/Select/WSSelect";
import WSTextField, { TextType } from "../../Components/TextBox/WSTextBox";
import WSTextAreaField from "../../Components/WSTextArea/WSTextArea";
import { callAPI, IRoleMain, IsSmallScreen, MasterPages, Method } from "../../commonFunctions/CommonFunctions";
import PermissionDenied from "../../commonFunctions/PermissionDenied";
import { getPermissions } from "../../commonFunctions/PermissionManger";
import WSRadioField from "../../Components/Radio/WSRadio";
import { WSIcons } from "../../commonFunctions/iIcons";
import WSDateField from "../../Components/DateField/WSDateField";
import WSImageUpload from "../../Components/FileUpload/WSImageUpload";

interface LoanAccountProps {
  control: Control<any>;
  errors: FieldErrors;
  register: UseFormRegister<any>;
  id: any;
  reset: UseFormReset<any>;
  departmentId?: string;
  setValue: any;
}
const LoanAccount: React.FC<LoanAccountProps> = ({
  control, errors, register, id, reset, departmentId, setValue, }) => {
  const isMobile=IsSmallScreen()
  useEffect(
    () => () => {
      reset();
    },
    [id, reset]
  );

 
 
  return (
    <>
          <Grid  style={{paddingLeft:5,paddingRight:20,position:'relative',margin:0,marginTop:'3rem'}} container spacing={2}>
           
             <Grid item xs={12} sm={6}>
                   <WSTextField
                                label={"Account Name *"}
                                {...register("accountName")}
                                id="accountName"
                                name="accountName"
                                control={control}
                                rules={{ required: false }}
                              />
              
            </Grid>
             <Grid item xs={12} sm={6}>
                   <WSTextField
                                label={"Lender Bank"}
                                {...register("lenderBank")}
                                id="lenderBank"
                                name="lenderBank"
                                control={control}
                                rules={{ required: false }}
                              />
              
            </Grid>
             <Grid item xs={12} sm={6}>
                   <WSTextField
                                label={"Account Number"}
                                {...register("accountNumber")}
                                id="accountNumber"
                                name="accountNumber"
                                control={control}
                                rules={{ required: false }}
                              />
              
            </Grid>
              <Grid item xs={12} sm={6}>
                   <WSTextField
                                label={"Current Balance *"}
                                {...register("currentBalance")}
                                id="currentBalance"
                                name="currentBalance"
                                control={control}
                                rules={{ required: false }}
                              />
              
            </Grid>
              <Grid item xs={12} sm={6}>
               <WSDateField
                id="balanceasof"
                name="balanceasof"
                label={" Balance As Of"}
                dateFormat="DD-MM-YYYY"
                denyFuturOrPast="custom"
                control={control}
                rules={{ required: false }}
              />
        </Grid>
         <Grid item xs={12} sm={6}>
               <WSSelectField
                rules={{ required: true }}
                {...register("loanReceivedIn")}
                id="loanReceivedIn"
                control={control}
                isMobile={isMobile}
                label="Loan Received In"
                name="loanReceivedIn"
              />
            </Grid>
             <Grid item xs={12} sm={6}>
                   <WSTextField
                                label={"Interest Rate % per annum"}
                                {...register("interestDate")}
                                id="interestDate"
                                name="interestDate"
                                control={control}
                                rules={{ required: false }}
                              />
              
            </Grid>
              <Grid item xs={12} sm={6}>
                   <WSTextField
                                label={"Term Duration (in months)"}
                                {...register("termDuration")}
                                id="termDuration"
                                name="termDuration"
                                control={control}
                                rules={{ required: false }}
                              />
              
            </Grid>
               <Grid item xs={12} sm={6}>
                   <WSTextField
                                label={"Processing Fee"}
                                {...register("processingFee")}
                                id="processingFee"
                                name="processingFee"
                                control={control}
                                rules={{ required: false }}
                              />
              
            </Grid>
             <Grid item xs={12} sm={6}>
               <WSSelectField
                rules={{ required: true }}
                {...register("processingFeePaidFrom")}
                id="processingFeePaidFrom"
                control={control}
                isMobile={isMobile}
                label="Processing Fee Paid From"
                name="processingFeePaidFrom"
              />
            </Grid>
        <Grid item xs={12} >
                <WSTextAreaField
              label={"Description"}
              id={"description"}
              name={"description"}
              control={control}
              rules={{ required: false }}
              rows={3}
            />
        </Grid>
          </Grid>
          </>

  );
};
export default LoanAccount;
